import { css, jsx } from '@emotion/core';
const getKeyDefault = (_item, i) => i;
const defaultProps = {
    getKey: getKeyDefault,
};
const rootStyle = css `
  list-style-type: none;
  margin: 0px;
  margin-block-end: 0px;
  margin-block-start: 0px;
  padding: 0px;
  padding-inline-start: 0px;
  -webkit-margin-after: 0px;
  -webkit-margin-before: 0px;
  -webkit-padding-start: 0px;
`;
const rootWithGap = (gap) => css `
  display: grid;
  grid-gap: ${gap}px;
`;
/**
 * Shows a list of items
 */
function List(props) {
    const listItems = props.items.map((item, i) => (jsx("li", { key: props.getKey(item, i) }, props.itemRenderer(item, i))));
    return (jsx("ul", { css: [rootStyle, props.gap && rootWithGap(props.gap)], id: props.id }, listItems));
}
List.defaultProps = defaultProps;
export default List;
